import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { tap } from 'rxjs'
import { login, loginSuccess } from './authentication.actions'
import { OpenAuthenticationService } from '@core/services/oauth.service'

@Injectable()
export class AuthenticationEffects {
  private actions$ = inject(Actions)

  constructor(
    private authService: OpenAuthenticationService
  ) {}

  // `login` carries no credentials — it redirects the browser to Identity (Authorization Code + PKCE).
  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      tap(() => this.authService.login())
    ),
    { dispatch: false }
  );

  loginSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginSuccess),
      tap((value) => this.authService.getFullUserInfo(value.user, value.token))
    ),
    { dispatch: false }
  );
}
